{
  "DefaultOpening": [
    "Sean Bean",
    "Mark Addy",
    "Nikolai Coster - Waldau",
    "Michelle Fairley",
    "Lena Headey",
    "Emilia Clarke",
    "Iain Glen",
    "Harry Lloyd\nKit Harington",
    "Sophie Turner\nMaisie Williams\nRichard Madden",
    "Alfie Allen\nIsaac Hempstead Wright\nJack Gleeson\nRory McCann",
    "and\nPeter Dinklage",
    "Nina Gold\nRobert Sterne",
    "Costume Designer\nMichele Clapton",
    "music by\nRamin Djawadi",
    "editor\nOral Norrie Ottey",
    "production designer\nGemma Jackson",
    "director of photography\nAlik Sakharov",
    "co-executive producer\nGeorge r.r. Martin",
    "co-executive producers\nVince Gerardis\nRalph Vicinanza",
    "co-executive producer\nGuymon Casady",
    "co-executive producer\nCarolyn Strauss",
    "producer\nMark Huffam",
    "producer\nFrank Doelger",
    "executive producers\nDavid Benioff\nD.B. Weiss",
    "created by\nDavid Benioff & D.B. Weiss",
    "based on\nA Song Of Ice And Fire\nby george r.r. martin",
    "#",
    "written by\nDavid Benioff & D.B. Weiss",
    "directed by\nTim Van Patten"
  ]
}